import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../../components/LoaderScreen";
import Swal from "sweetalert2";
import request from "../../../../Helpers/API";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { CargarConvenioModal } from "../Modal/CargarConvenioModal";
import { DescargarConvenioModal } from "../Modal/DescargarConvenioModal";
import SeleccionarGestionModal from "../Modal/SeleccionarGestionModal";
import GenerarConvenioModal from "../Modal/GenerarConvenioModal";
import RegistrarComentarioModal from "../Modal/RegistrarComentarioModal";
import MedioContactoModal from "../Modal/MedioContactoModal";
import RegistrarGestionConvenioModal from "../Modal/RegistrarGestionConvenioModal";
import RegistrarGestionComentarioModal from "../Modal/RegistrarGestionComentarioModal";

export const ListadoConveniosClienteScreen = () => {
    const history = useHistory();
    const { state } = useLocation();
    const idcliente = state.idcliente;
    const [convenios, setConvenios] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [openModalGestion, setOpenModalGestion] = useState(false);
    const [modalDescarga, setModalDescarga] = useState(false);
    const [gestion, setGestion] = useState({
        mediocontacto: "",
        gestion: "",
        objecion: ""
    });
    const [folio, setFolio] = useState("");
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleOpenModal = (folio) => {
        setOpenModal(true);
        setFolio(folio);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleOpenModalGestion = () => {
        setOpenModalGestion(true);
    };

    const handleCloseModalGestion = () => {
        setOpenModalGestion(false);
    };

    const abrirModalDescarga = (folio) => {
        setModalDescarga(true);
        setFolio(folio);
    };

    const cerrarModalDescarga = () => {
        setModalDescarga(false);
    };

    const [openGenerarConvenioModal, setOpenGenerarConvenioModal] = useState(false);

    const handleOpenGenerarConvenioModal = () => {
        setOpenGenerarConvenioModal(true);
    };

    const handleCloseGenerarConvenioModal = () => {
        setOpenGenerarConvenioModal(false);
    };

    const [openRegistrarComentarioModal, setOpenRegistrarComentarioModal] = useState(false);

    const handleOpenRegistrarComentarioModal = () => {
        setOpenRegistrarComentarioModal(true);
    };
    const handleCloseRegistrarComentarioModal = () => {
        setOpenRegistrarComentarioModal(false);
    };

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        onExecute();
        setLoader({ ...loader, mostrar: false });
    }, [openModalGestion]);

    const onExecute = () => {
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `ListadoConveniosCliente/Convenios?idcliente=${idcliente}`
                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setConvenios(result);
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };

    const onGeneraExcel = (cliente) => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ListadoConveniosCliente/ImprimirExcelReporte?idcliente=${cliente}`)
            .then(({ documento, filename }) => {
                const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${filename}.xlsx`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
            });
    };

    const onGeneraPDF = (cliente) => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ListadoConveniosCliente/ImprimirPDFReporte?idcliente=${cliente}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = `data:application/pdf;base64, ${result.documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${result.nombredocumento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    };

    const SeleccionGestion = (gestion) => {
        setGestion({ gestion: gestion })
        if (gestion === "C") {
            handleOpenModalGestion(true); // Abre el modal de Generar Convenios
        } else if (gestion === "M") {
            // handleOpenRegistrarComentarioModal(true); // Abre el modal de Registrar Comentario
            history.push(
                "/Creditoycobranza/ListadoComentariosCliente",
                {
                    idcliente: idcliente,
                    facturasSeleccionadas: state.facturasSeleccionadas,
                    saldo: state.saldo,
                    moratorios: state.moratorios,
                    interespactado: state.pactados,
                    total: state.total,
                    responsable: state.responsable,
                    razonsocial: state.razonsocial
                }
            )
        } else if (gestion === "R") {
            history.push(
                "/Creditoycobranza/ListadoReestructuracionesCliente",
                {
                    idcliente: idcliente,
                    facturasSeleccionadas: state.facturasSeleccionadas,
                    saldo: state.saldo,
                    moratorios: state.moratorios,
                    interespactado: state.pactados,
                    total: state.total,
                    responsable: state.responsable,
                    razonsocial: state.razonsocial
                }
            )
        }
    };


    return (
        <PlantillaScreen
            titulo={`CONVENIOS REALIZADOS A ${state.razonsocial}`}
            className={"convenio-pago-main-screen"}
            className_main={1}
        >
            <div className="listado-convenios-porcliente-actions">
                <div
                    className="listado-convenios-porcliente-actions-regresar"
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="buttons">
                    {/* <button className="agregar"
                        onClick={() => handleOpenModalGestion()}
                    >
                        <i className="" /> Agregar
                    </button> */}
                    <button className="excel"
                        onClick={() => onGeneraExcel(idcliente)}
                    >
                        <i className=" icon-file-excel" /> Excel
                    </button>
                    <button className="PDF"
                        onClick={() =>
                            onGeneraPDF(idcliente)
                        }
                        style={{ backgroundColor: '#940404' }}>
                        PDF
                    </button>
                </div>
            </div>
            <div className="listado-convenios-porcliente">
                <LoaderScreen loader={loader} />
                <div className="listado-convenios-porcliente-header">
                    <div className="listado-convenios-porcliente-header-title">
                        <FormatListNumberedIcon /> Listado de Convenios Realizados
                    </div>
                    <div className="buttons-gestion">
                        <button className="agregar"
                            onClick={() => SeleccionGestion("R")}
                        >
                            <i className="" /> Reestructuraciones
                        </button>
                        <button className="agregar"
                            onClick={() => SeleccionGestion("C")}
                        >
                            <i className=" icon-file-excel" /> Realizar Convenio
                        </button>
                        <button className="agregar"
                            onClick={() =>
                                SeleccionGestion("M")
                            }>
                            Ver Comentarios
                        </button>
                    </div>
                </div>
                <div className="listado-convenios-porcliente-container scroll-4">
                    <table>
                        <thead>
                            <tr>
                                <th>Razon Social</th>
                                <th>
                                    <div>Saldo</div>
                                </th>
                                <th>
                                    <div>Monto Convenio</div>
                                </th>
                                <th>
                                    <div>Saldo por Conveniar</div>
                                </th>
                                <th>
                                    <div>Vencimiento Convenio</div>
                                </th>
                                <th>
                                    <div>Responsable</div>
                                </th>

                                <th>
                                    <div>Opciones</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {convenios.map((vc) => (
                                <tr>
                                    <td>{vc.razon_social}</td>
                                    <td className="ta-right">{FormatMoney(vc.saldo)}</td>
                                    <td className="ta-right">{FormatMoney(vc.monto)}</td>
                                    <td className="ta-right">{FormatMoney(vc.saldo_conveniar)}</td>
                                    <td className="ta-center">
                                        {vc.fecha_convenio.split("T")[0]}
                                    </td>
                                    <td>{vc.nombreCompleto}</td>

                                    <td>
                                        <div className="convenio-pago-acciones-listado">
                                            <div
                                                className="boton-descargar-convenio-pago-pdf"
                                                onClick={() => abrirModalDescarga(vc.folio)}
                                            >
                                                <CloudDownloadIcon /> Descargar{" "}
                                            </div>
                                            <div
                                                className="boton-subir-evidencia-convenio-pago"
                                                onClick={() => handleOpenModal(vc.folio)}
                                            >
                                                <CloudUploadIcon />
                                                Cargar
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="contador-convenios-cliente-encontrados">
                        Convenios Encontrados: {convenios.length}
                    </div>
                </div>

                {/* <SeleccionarGestionModal
                    open={openModalGestion}
                    onClose={handleCloseModalGestion}
                    facturasSeleccionadas={state.facturasSeleccionadas}
                    idcliente={state.idcliente}
                    saldo={state.saldo}
                    moratorios={state.moratorios}
                    interespactado={state.interespactado}
                    total={state.total}
                    responsable={state.responsable}
                /> */}
                <CargarConvenioModal
                    open={openModal}
                    handleCloseModal={handleCloseModal}
                    folio={folio}
                />
                <DescargarConvenioModal
                    open={modalDescarga}
                    onClose={cerrarModalDescarga}
                    folio={folio}
                />
                <RegistrarGestionConvenioModal
                    open={openModalGestion}
                    onClose={handleCloseModalGestion}
                    facturasSeleccionadas={state.facturasSeleccionadas}
                    mediocontacto={gestion.mediocontacto}
                    gestionselected={gestion.gestion}
                    objecion={gestion.objecion}
                    saldo={state.saldo}
                    moratorios={state.moratorios}
                    interespactado={state.interespactado}
                    total={state.total}
                    idcliente={idcliente}
                />

                <GenerarConvenioModal
                    open={openGenerarConvenioModal}
                    onClose={handleCloseGenerarConvenioModal}
                    facturasSeleccionadas={state.facturasSeleccionadas}
                    mediocontacto={gestion.mediocontacto}
                    gestion={gestion.gestion}
                    objecion={gestion.objecion}
                    saldo={state.saldo}
                    moratorios={state.moratorios}
                    interespactado={state.interespactado}
                    total={state.total}
                    idcliente={idcliente}
                />
                <RegistrarGestionComentarioModal
                    open={openRegistrarComentarioModal}
                    onClose={handleCloseRegistrarComentarioModal}
                    // onRegresar={handleRegresarDesdeComentario}
                    facturasSeleccionadas={state.facturasSeleccionadas}
                    mediocontacto={gestion.mediocontacto}
                    gestion={gestion.gestion}
                    objecion={gestion.objecion}
                    saldo={state.saldo}
                    moratorios={state.moratorios}
                    interespactado={state.interespactado}
                    total={state.total}
                    responsable={state.responsable}
                    idcliente={idcliente}
                />
            </div>
        </PlantillaScreen>
    );
};
